module.exports = __webpack_public_path__ + "static/media/Justbulk---Takeaway-Packaging-3.a3ed4f05.png";